import { render } from "./j-checkbox.vue?vue&type=template&id=72b67b40&scoped=true"
import script from "./j-checkbox.vue?vue&type=script&lang=js"
export * from "./j-checkbox.vue?vue&type=script&lang=js"

import "./j-checkbox.vue?vue&type=style&index=0&id=72b67b40&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b67b40"]])

export default __exports__